<template>
  <b-modal :active.sync="active"
      has-modal-card full-screen :can-cancel="false">
    <div class="modal-card" >
      <header class="modal-card-head">
        <div class="columns is-centered" style="width: 100%">
            <div class="column is-three-fifths">
              <p class="modal-card-title">Editar Nómina</p>
            </div>
        </div>
      </header>
      <section class="modal-card-body">
        <div class="columns is-centered" style="width: 100%">
            <div class="column is-three-fifths">
              <b-tabs position="is-centered" class="block" v-model="activeTab">
                <b-tab-item label="Nómina de binomios">
                  <payroll-form-table :event="event" :event-id="eventId" :reload.sync="reload" @edit="editExecution" :last-time.sync="lastTime"/>
                </b-tab-item>
                <b-tab-item label="Añadir Binomio">
                  <payroll-form :event="event" @saved="saved" :last-time="lastTime"/>
                </b-tab-item>
                <b-tab-item label="Modificar Binomio" v-if="executionId">
                  <payroll-form :event="event" @saved="saved" :execution-id.sync="executionId"/>
                </b-tab-item>
              </b-tabs>
            </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="columns is-centered" style="width: 100%">
            <div class="column is-three-fifths">
              <div class="columns">
                <div class="column">
                  <b-button expanded @click="cancel" :disabled="isLoading">Cerrar</b-button>
                </div>
              </div>
            </div>
        </div>
      </footer>
      <b-loading :active.sync="loadingEvent" :is-full-page="false"></b-loading>
    </div>
  </b-modal>
</template>

<script>
import PayrollFormTable from './PayrollFormTable'
import PayrollForm from './PayrollForm'
import EventService from '@/services/EventService'

export default {
  components: {
    PayrollFormTable,
    PayrollForm
  },
  props: {
    active: {
      type: Boolean,
      required: false,
      default: false
    },
    eventId: {
      required: false,
      default: null
    }
  },
  created () {
    this.getEvent()
  },
  data () {
    return {
      lastTime: null,
      isLoading: false,
      loadingEvent: false,
      event: null,
      activeTab: 0,
      reload: false,
      executionId: null
    }
  },
  methods: {
    cancel () {
      this.$emit('close')
      this.$emit('update:active', false)
    },
    saved () {
      this.activeTab = 0
      this.reload = true
    },
    editExecution (id) {
      this.executionId = id
      this.$nextTick(() => {
        this.activeTab = 2
      })
    },
    async getEvent () {
      let response = await EventService.getEvent(this.eventId)
      this.event = response.data.data
      if (!this.lastTime) {
        this.lastTime = this.event.start_at
      }
    }
  },
  watch: {
  },
  computed: {
  }
}
</script>
